import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2","key":"svg-0"}],["path",{"d":"M8 6h.01","key":"svg-1"}],["path",{"d":"M16 18h.01","key":"svg-2"}],["path",{"d":"M10 9v6","key":"svg-3"}],["path",{"d":"M14 9l-3 3l3 3","key":"svg-4"}],["path",{"d":"M10 12h1","key":"svg-5"}]]

const IconPlayCardK = createReactComponent('outline', 'play-card-k', 'PlayCardK', __iconNode);

export default IconPlayCardK;